import React, { useEffect } from "react";
import {sizes} from "../theme/themeSizes";

export const isMobileScreen = () => window.innerWidth < sizes.mobile
